<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({ name: 'DiscountDetail' });
</script>
<!-- 优惠详情弹窗组件 -->
<template>
  <el-dialog
    v-model="visible"
    :title="$t('优惠详情')"
    :close-on-click-modal="false"
    top="20vh"
    width="72%"
    :show-close="false"
  >
    <div class="discount-table-contain">
      <BasicTable
        v-if="visible"
        show-overflow-tooltip
        :data="data"
        :columns="isRefund ? columnsRefundDiscount : columnsDiscount"
        :filter-options="filterOptions"
      >
        <!-- 优惠类型 -->
        <template #type="{ row }">
          {{ getDiscountTypeName(row.type, discountTypeList) }}
        </template>
        <!-- 优惠范围 -->
        <template #scope="{ row }">
          {{ getDiscountTypeName(row.scope, discountScopeList) }}
        </template>
      </BasicTable>
    </div>
    <div class="dialog-footer">
      <el-button type="primary" class="btn mt-8" plain @click="visible = false">
        {{ closeText || $t('关闭') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { BasicTable } from '../../BasicTable';
import { i18n } from '@klondpay/locales';

;

const props = defineProps({
  /** v-model 控制弹窗显隐 */
  modelValue: {
    type: Boolean,
    default: false,
  },
  /** 优惠列表数据 */
  data: {
    type: Array,
    default: () => [],
  },
  /** 是否为退款场景（退款时列配置有所不同） */
  isRefund: {
    type: Boolean,
    default: false,
  },
  /** 关闭按钮文字（可选，默认使用国际化的"关闭"） */
  closeText: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['update:modelValue']);

// 双向绑定 visible
const visible = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val),
});

// 内部不显示工具栏和搜索
const filterOptions = {
  showToolbar: true,
  queryPlaceholder: '',
};

// ---------- 列配置 ----------
const { t } = i18n.global;

// 消费优惠列
const columnsDiscount = ref([
  {
    label: t('优惠类型'),
    minWidth: 120,
    slot: 'type',
  },
  {
    label: t('优惠名称'),
    prop: 'name',
    minWidth: 120,
  },
  {
    label: t('优惠范围'),
    minWidth: 120,
    slot: 'scope',
  },
  {
    label: t('货币类型'),
    minWidth: 120,
    prop: 'currency',
  },
  {
    label: t('优惠券面额'),
    minWidth: 120,
    prop: 'amount',
  },
]);

// 退款优惠列
const columnsRefundDiscount = ref([
  {
    label: t('优惠类型'),
    minWidth: 120,
    slot: 'type',
  },
  {
    label: t('优惠范围'),
    minWidth: 120,
    slot: 'scope',
  },
  {
    label: t('优惠券退款额'),
    minWidth: 120,
    prop: 'refund_amount',
  },
  {
    label: t('货币类型'),
    minWidth: 120,
    prop: 'currency',
  },
  {
    label: t('优惠券面额'),
    minWidth: 120,
    prop: 'amount',
  },
]);

// ---------- 优惠类型/范围映射 ----------
const discountTypeList = [
  { name: t('优惠券'), code: 'DISCOUNT' },
  { name: t('代金券'), code: 'COUPON' },
];

const discountScopeList = [
  { name: t('全场代金券'), code: 'GLOBAL' },
  { name: t('单品优惠'), code: 'SINGLE' },
];

/**
 * 根据 code 从映射列表中获取名称
 */
function getDiscountTypeName(code: string, list: { name: string; code: string }[]) {
  const matched = list.find((item) => item.code === code);
  return matched ? matched.name : code ? code : '/';
}
</script>

<style lang="scss" scoped>
.dialog-footer {
  display: flex;
  justify-content: center;
  width: 100%;
  padding-top: -10px;
  padding-bottom: 20px;
  line-height: 22px;
}

.discount-table-contain {
  padding: 20px 24px !important;

  /* 隐藏表格工具条和分页容器 */
  :deep(.table-toolbar) {
    display: none !important;
  }

  :deep(.table-pg-contain) {
    display: none !important;
  }

  /* 表头样式优化 */
  :deep(.el-table__header-wrapper th) {
    color: #303133 !important;
    background-color: #f1f6ff !important;
  }

  /* 表格行悬停样式 */
  :deep(.el-table__body .el-table__row:hover > td) {
    background-color: #f1f6ff !important;
  }
}
</style>
